module.exports = __webpack_public_path__ + "static/media/radon-house.8b54c1c7.jpg";